module.exports = __webpack_public_path__ + "static/media/Burger.07a6ffb5.PNG";